import type { ForwardRefRenderFunction, ReactNode } from 'react';
import { forwardRef } from 'react';
import cx from 'classnames';

import { GlitterIcon } from '@motorway/mw-highway-code';

import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';

import styles from './SectionHeading.module.scss';

type SectionHeadingProps = {
	className?: string;
	text: ReactNode;
};

const SectionHeading: ForwardRefRenderFunction<HTMLHeadingElement, SectionHeadingProps> = (
	{ className, text },
	ref,
) => {
	const {
		maxWidth: { breakpointTablet: isTablet },
	} = useBreakpoint();
	return (
		<h1 ref={ref} className={cx(styles.heading, className)}>
			<GlitterIcon size={isTablet ? 'small' : 'medium'} />
			{text}
		</h1>
	);
};

export default forwardRef(SectionHeading);
